import { render } from "./NewsfeedPost.vue?vue&type=template&id=6f031290"
import script from "./NewsfeedPost.vue?vue&type=script&lang=js"
export * from "./NewsfeedPost.vue?vue&type=script&lang=js"

import "./NewsfeedPost.vue?vue&type=style&index=0&id=6f031290&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__